/* eslint jsx-a11y/no-static-element-interactions:0 */
import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const ErrorModal = ({ children, text, onClose }) => (
    <div className="pp-errorModal__overlay">
        <div className="pp-errorModal__container">
            <div className="pp-errorModal__header">
                <button
                    className="ui-btn"
                    onClick={onClose}
                >
                    <Svg
                        iconName="cross"
                        size="Medium"
                    />
                </button>
            </div>
            <div className="pp-errorModal__content">
                { children || text }
            </div>
            <button
                className="pp-errorModal__button ui-btn ui-btn_major"
                onClick={onClose}
            >
                Ok
            </button>
        </div>
    </div>
);

ErrorModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    text: PropTypes.string,
    children: PropTypes.node,
};

export default ErrorModal;



// WEBPACK FOOTER //
// ./src/js/shared/ErrorModal.jsx